export default "__VITE_ASSET__fc69079c__"